<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form">
        <template slot="buttonArea">
          <el-button type="primary" @click="add" size="small">{{ $t('text.addConfig') }}</el-button>
        </template>

        <template slot="tableColumn">
          <el-table-column prop="id" :label="$t('text.configId')" align="center" width="110px"/>
          <el-table-column prop="code" :label="$t('text.parserCode')" align="center" width="300px"/>
          <el-table-column prop="mailSubject" :label="$t('text.mailSubject')" align="center" width="250px"/>
          <el-table-column prop="collectionText" :label="$t('text.collectionText')" align="center" width="300px" :formatter="formatter.formatNullableString"/>
          <el-table-column prop="parserConfig" :label="$t('text.parserConfig')" align="center" width="300px">
            <template slot-scope="{ row }">
              <div v-if="row.parserConfig">
                <el-popover v-if="row.parserConfig && row.parserConfig.length > 10"
                            placement="top-start"
                            width="400px"
                            trigger="hover">
                  <pre>{{ row.parserConfig }}</pre>
                  <div slot="reference" class="remark">
                    {{ row.parserConfig }}
                  </div>
                </el-popover>
                <div v-else>{{ row.parserConfig }}</div>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="creationTime" :label="$t('text.creationTime')" align="center" width="180px" :formatter="formatter.formatDate"/>
          <el-table-column prop="creatorId" :label="$t('text.creator')" align="center" width="150px"/>
          <el-table-column prop="modificationTime" :label="$t('text.updateTime')" align="center" width="180px" :formatter="formatter.formatDate"/>
          <el-table-column prop="modifierId" :label="$t('text.updatedBy')" align="center" width="150px" :formatter="formatter.formatNullableString"/>
          <el-table-column fixed="right" :label="$t('text.actions')" align="center" width="100">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" plain @click="edit(scope.row)">{{ $t('text.edit') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </page>
      <MailParserInfoEdit :show.sync="showDialog" :value="formData" :action="action"/>
    </div>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";
import formatter from "@/utils/formatter";
import MailParserInfoEdit from "@/views/route/mailParserInfo/MailParserInfoEdit.vue";

export default {
  name: "MailParserInfo",
  computed: {
    formatter() {
      return formatter
    }
  },
  components: {MailParserInfoEdit, Page},
  data() {
    return {
      url: "/mailParserInfo/selectList",
      action: "",
      showDialog: false,
      formData: null,
      form: {}
    };
  },
  methods: {
    add() {
      this.action = "add";
      this.showDialog = true;
    },
    edit(row) {
      this.action = "edit";
      this.formData = row;
      this.showDialog = true;
    }
  }
}
</script>
<style scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.el-popover pre {
  max-width: 800px;
  max-height: 500px;
  overflow: auto;
}
</style>